import Link, { LinkProps } from "next/link";
import { useStore } from "~/hooks/useStore";
import { nowdoApi } from "~/hooks/rtk-query-api";
import { AppStore } from "~/store";
import { CustomPageLink } from "~/types/customPageLink";

export const loadHomePageData = async (store: AppStore) => {
  const tasks: Promise<unknown>[] = [
    store.dispatch(nowdoApi.endpoints.listClassrooms.initiate({})),
    store.dispatch(nowdoApi.endpoints.listArchives.initiate({})),
    store.dispatch(nowdoApi.endpoints.listProfessionals.initiate({ sort: "classroom" })),
  ];
  const userQuery = nowdoApi.endpoints.getMe.select()(store.getState());

  if (userQuery.data) {
    tasks.push(store.dispatch(nowdoApi.endpoints.listMeFollowing.initiate({})));
  }

  await Promise.all(tasks);
};

export const HomePageLink: CustomPageLink = ({ aProps = {}, children, ...linkProps }) => {
  const store = useStore();

  const props = {
    ...linkProps,
    ...aProps,
  } as Partial<LinkProps>;

  return (
    <Link {...props} href="/" onMouseEnter={() => aProps.target !== "_blank" && loadHomePageData(store)}>
      {children}
    </Link>
  );
};
